export default __webpack_public_path__ + "static/media/breakfast2.6d7a70ba.png";